export default __webpack_public_path__ + "static/media/logo.34adfde9.png";